var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.75 34V18.75C43.75 12.5464 38.7036 7.5 32.5 7.5C26.2964 7.5 21.25 12.5464 21.25 18.75V34H13.75V18.75C13.75 8.41187 22.1619 0 32.5 0C42.8381 0 51.25 8.41187 51.25 18.75V34H43.75Z",
    fill: "#F1B51C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.25 64H13.75C10.6483 64 8.125 61.4767 8.125 58.375V35.875C8.125 32.7733 10.6483 30.25 13.75 30.25H51.25C54.3517 30.25 56.875 32.7733 56.875 35.875V58.375C56.875 61.4767 54.3517 64 51.25 64Z",
    fill: "#C4C4C4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.125 43.375C38.125 40.2733 35.6017 37.75 32.5 37.75C29.3983 37.75 26.875 40.2733 26.875 43.375C26.875 45.8176 28.447 47.8794 30.625 48.6558V54.625C30.625 55.6614 31.4636 56.5 32.5 56.5C33.5364 56.5 34.375 55.6614 34.375 54.625V48.6558C36.553 47.8794 38.125 45.8176 38.125 43.375Z",
    fill: "#047B84"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLock);
export default __webpack_public_path__ + "static/media/ic_lock.83d11c3baea9ebbc0cb392136ac5b771.svg";
export { ForwardRef as ReactComponent };